import React from 'react';
import MockupShell from './MockupShell';

const PROSPECTS = [
  { initial: 'J', name: 'James R.',   pos: 1, waited: '3 min',  state: 'GLOBAL', city: 'Houston, TX' },
  { initial: 'A', name: 'Amelia T.',  pos: 2, waited: '11 min', state: 'GLOBAL', city: 'Charlotte, NC' },
  { initial: 'K', name: 'Kevin L.',   pos: 3, waited: '18 min', state: 'GLOBAL', city: 'Phoenix, AZ' },
  { initial: 'S', name: 'Sarah K.',   pos: 4, waited: '22 min', state: 'GLOBAL', city: 'Portland, OR' },
  { initial: 'D', name: 'Devon M.',   pos: 5, waited: '34 min', state: 'GLOBAL', city: 'Tampa, FL' },
  { initial: 'P', name: 'Priya N.',   pos: 6, waited: '41 min', state: 'GLOBAL', city: 'Denver, CO' },
  { initial: 'T', name: 'Tyrese B.',  pos: 7, waited: '55 min', state: 'GLOBAL', city: 'Atlanta, GA' },
  { initial: 'M', name: 'Maria G.',   pos: 8, waited: '1h 12m', state: 'GLOBAL', city: 'Albuquerque, NM' },
];

export default function GlobalPifList() {
  return (
    <MockupShell
      title="Global PIF List"
      subtitle="Prospects available to be claimed by any active member via Pay-It-Forward."
      dataTestId="mockup-global-pif"
    >
      <div className="mk-compliance" style={{ marginBottom: 16 }}>
        <strong>How the Global PIF list works.</strong> Prospects sit here after their sponsor&apos;s
        Personal queue and Network queue windows expire. Any active member can claim a prospect by
        paying their <strong>5.95 USDT (TRC-20) Pay-It-Forward</strong> directly to the network
        via NowPayments. The platform does <strong>not</strong> hold this payment — it routes
        member-to-member, non-custodially.
      </div>

      <div className="mk-grid mk-grid--4" style={{ marginBottom: 18 }}>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">In queue</span><span className="mk-stat-value">142</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Claimed today</span><span className="mk-stat-value">38</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Avg time to claim</span><span className="mk-stat-value">14m</span></div></div>
        <div className="mk-card"><div className="mk-stat"><span className="mk-stat-label">Your tier</span><span className="mk-stat-value" style={{ color: 'var(--mk-gold)' }}>ROOKIE</span></div></div>
      </div>

      <div className="mk-card" style={{ padding: 0 }}>
        <div style={{ padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid var(--mk-border)', flexWrap: 'wrap', gap: 10 }}>
          <strong style={{ fontSize: 14 }}>Available prospects</strong>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <span className="mk-badge mk-badge--gold">All cities</span>
            <span className="mk-badge mk-badge--muted">Newest first</span>
            <span className="mk-badge mk-badge--muted">Auto-refresh: 30s</span>
          </div>
        </div>

        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {PROSPECTS.map((p, i) => (
            <li
              key={p.name}
              data-testid={`pif-prospect-${i}`}
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr auto auto',
                gap: 14,
                alignItems: 'center',
                padding: '14px 18px',
                borderBottom: i < PROSPECTS.length - 1 ? '1px solid var(--mk-border)' : 'none',
              }}
            >
              <span style={{
                width: 38, height: 38, borderRadius: '50%',
                background: 'linear-gradient(135deg, #ffd968, #d99410)',
                color: '#0b0f15', display: 'grid', placeItems: 'center',
                fontWeight: 800, fontSize: 15,
              }}>{p.initial}</span>
              <div>
                <strong style={{ fontSize: 14 }}>{p.name}</strong>
                <div style={{ fontSize: 12, color: 'var(--mk-muted)' }}>
                  {p.city} · Waiting {p.waited} · Queue position #{p.pos}
                </div>
              </div>
              <span className="mk-badge mk-badge--amber">{p.state}</span>
              <button className="mk-btn" data-testid={`pif-claim-btn-${i}`}>
                Claim · 5.95 USDT
              </button>
            </li>
          ))}
        </ul>

        <div style={{ padding: 16, textAlign: 'center', borderTop: '1px solid var(--mk-border)' }}>
          <span style={{ fontSize: 12, color: 'var(--mk-muted)' }}>134 more prospects · Load more</span>
        </div>
      </div>

      <div className="mk-compliance" style={{ marginTop: 16, fontSize: 11 }}>
        <strong>Payment routing.</strong> Claim payments are processed via NowPayments invoice on
        the TRON TRC-20 network. Funds settle directly to the previous sponsor&apos;s wallet on
        chain. Admin only receives the system Pay-It-Forward when it is the admin&apos;s rotation
        position. No pooled balances. No custodial holdings. No payout redistribution.
      </div>
    </MockupShell>
  );
}
